export default __webpack_public_path__ + "approved-active.svg";